export function getAnalysesPlaceFilterLabel(hasMetro: boolean) {
  return hasMetro ? 'Метро, район' : 'Район'
}

export function getAnalysesPlaceSearchPlaceholder(hasMetro: boolean) {
  return hasMetro ? 'Название станции или района' : 'Название района'
}
